
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");

module.exports = Model({
	name: "careplanschema",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_loaded: false,
	refresh: refresh
});

function init() {
	this.push({
		data: {
			properties: {}
		}
	});
}

function listeners() {
	return {
		"connectivity:online": refresh
	};
}

function triggers() {
	return {
		load: load,
	};
}

function load() {
	if(this._loaded) return;
	this._loaded = true;
	this.refresh();
}

function refresh() {
	if(!this._loaded) return;
	// Call the API to load the careplan schema
	this.api.careplan.schema()
		.then(this.push.bind(this));
}
